import gql from 'graphql-tag';
import { kmsClient } from 'api';
import { useMutation } from '@apollo/react-hooks';
import {
  UpdateContentDataSourceMutation,
  UpdateContentDataSourceMutationVariables
} from './__generated__/UpdateContentDataSourceMutation';

const UPDATE_CONTENT_DATA_SOURCE_MUTATION = gql`
  mutation UpdateContentDataSourceMutation($id: ID!, $name: String!, $path: String!, $dataSourceType: String!) {
    updateContentDataSource(id: $id, name: $name, path: $path, dataSourceType: $dataSourceType) {
      contentDataSource {
        id
        name
        path
        dataSourceType
      }
      errors
    }
  }
`;

export const useUpdateContentDataSourceMutation = () => {
  return useMutation<UpdateContentDataSourceMutation, UpdateContentDataSourceMutationVariables>(
    UPDATE_CONTENT_DATA_SOURCE_MUTATION,
    {
      client: kmsClient
    }
  );
};
